<template>
  <div v-if="displayPricingLink" class="assignment-function d-flex">
    <router-link
      :to="dynamicPricesLink"
      :disabled="!isItemsEditable"
      :class="'btn ml-3 btn-height-md btn-outline-secondary no-wrap' + (isItemsEditable ? '' : ' disabled')"
    >
      Dynamic Pricing
    </router-link>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { computed, defineComponent } from 'vue'
import { PENDING, VALIDATING, VALIDATION_COMPLETE } from '@/const/AssignmentStatuses'
import { CONSOLIDATE } from '@/const/AssignmentTypes'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { STAFF_ASSIGNMENT_PRICES } from '@/types/router'

export default defineComponent({
  name: 'PricingLink',
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const accountStore = useAccountStore()

    const assignment = computed(() => assignmentSummaryStore.assignment as Assignment)
    const ability = computed(() => accountStore.ability)

    const isItemsEditable = computed(() => assignmentSummaryStore.isItemsEditable)

    const dynamicPricesLink = computed(() => ({
      name: STAFF_ASSIGNMENT_PRICES,
      params: { id: assignment.value.reference },
    }))

    const displayPricingLink = computed(
      () =>
        assignment.value.type === CONSOLIDATE &&
        [PENDING, VALIDATING, VALIDATION_COMPLETE].includes(assignment.value.status) &&
        ability.value.can('manage', 'prices'),
    )

    return {
      isItemsEditable,
      dynamicPricesLink,
      displayPricingLink,
    }
  },
})
</script>
